<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Instalação da sede corporativa na cidade de São Paulo (SP)</h2>
          <p>
            O ano de 2004 representou um grande passo na história da
            <strong>JBS</strong> com a mudança de sua sede para a cidade de São
            Paulo, centralizando todas as operações num prédio icônico para o
            setor de carnes.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2004/2004-1.png"
            alt=""
            class="nomargin"
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2003/07/09/g/20030709-40076-spo-25-eco-b8-not-xsgkpqq.jpg'
              )
            "
          />
          <img
            src="../assets/img/2004/2004-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2003/10/26/g/20031026-40185-spo-35-eco-b9-not-aseswaq.jpg'
              )
            "
            class="ml-a nomargin"
          />
          <img
            src="../assets/img/2004/2004-3.png"
            alt=""
            class="nomargin"
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2004/06/29/g/20040629-40432-spo-62-eco-h11-not-kgkgehq.jpg'
              )
            "
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Liderança nas exportações e a ascensão dos grills</h2>
          <p>
            Após temporadas rivalizando com EUA e Austrália, o Brasil se torna
            em 2003 o líder mundial em volume de exportações de carne bovina e
            de carne de frango. O País também começa a exportar carne direto
            para a China, um dos maiores mercados consumidores do mundo. A
            oferta de proteína movimenta a indústria dos eletrodomésticos, com o
            aparecimento dos grills elétricos. O fast-food, aliás, estava em
            declínio lá fora, sendo questionado por alimentos ultraprocessados,
            cheios de gorduras e açúcares.
          </p>
          <blockquote>
            A humanidade sempre assou carne, mas aparelhos como esse trazem um
            resgate ao processo original do alimento, em contraposição ao
            fast-food”,<span>
              diz o especialista em alimentação do Senac.
            </span>
          </blockquote>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2004/2004-4.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2005/02/20/g/20050220-40668-spo-31-eco-b7-not-eaewkkq.jpg'
              )
            "
          />
          <img
            src="../assets/img/2004/2004-5.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2004/08/27/g/20040827-40491-spo-61-cd2-d6-not-qakaxhq.jpg'
              )
            "
          />
          <img
            src="../assets/img/2004/2004-6.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2004/08/27/g/20040827-40491-spo-61-cd2-d6-not-qakaxhq.jpg'
              )
            "
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 330px 1fr 250px 1fr;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
      padding: 120px 20px;
    }
    gap: 20px;
  }
  &__warpper {
    position: relative;

    img {
      cursor: pointer;
      transition: 0.3s ease-in-out;
      display: block;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      &--image {
        @include media("<=desktop") {
          img {
            margin: 20px auto;
          }
          .nomargin {
            margin: 0 auto;
          }
        }
        span {
          display: block;
          width: 65px;
          color: color(cText);
          margin-right: auto;
          margin-top: auto;
          strong {
            color: color(cText);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }

        .ml-a {
          margin-left: auto;
          margin-bottom: 20px;
          margin-right: 10px;
        }
      }
      h2 {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        padding-block: 50px;
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin-bottom: 10px;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          span {
            color: color(cText);
            font-family: font(primary);
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 135%;
            @include media("<=desktop") {
              color: color(cWhite);
            }
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: url("../assets/img/2004/fundo.jpg");
      width: 47%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        width: 100%;
      }
    }
  }
}
</style>
